import { ADD_INFO_FEATURE, REMOVE_INFO_FEATURE } from '../actions/actionTypes';

const initialState = [];

const layersFeatureReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_INFO_FEATURE:
      return [payload];
    case REMOVE_INFO_FEATURE:
      return [];
    default:
      return state;
  }
};

export default layersFeatureReducer;
